import { render, staticRenderFns } from "./Center_Left.vue?vue&type=template&id=2fb06878"
import script from "./Center_Left.vue?vue&type=script&lang=js"
export * from "./Center_Left.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports